export function getPlanID(plan) {
  if (!plan) {
    return null;
  }

  if (plan["ID"] !== undefined && plan["ID"] !== null) {
    return plan["ID"];
  }

  if (plan["id"] !== undefined && plan["id"] !== null) {
    return plan["id"];
  }

  return null;
}

export function getPlanFee(plan) {
  if (!plan) {
    return 0;
  }

  if (plan["Fee"] !== undefined && plan["Fee"] !== null) {
    return Number(plan["Fee"]);
  }

  if (plan["fee"] !== undefined && plan["fee"] !== null) {
    return Number(plan["fee"]);
  }

  return 0;
}

export function getPlanAllowsCompanyPurchase(plan) {
  if (!plan) {
    return true;
  }

  if (plan["AllowsCompanyPurchase"] !== undefined) {
    return plan["AllowsCompanyPurchase"];
  }

  if (plan["allows_company_purchase"] !== undefined) {
    return plan["allows_company_purchase"];
  }

  return true;
}
